import { Reveal } from './reveal';
import { ButtonLink } from './button-link';

type CtaTile = {
  to: string;
  label: string;
  title: string;
  action: string;
};

type CtaDuoProps = {
  primary: CtaTile;
  secondary: CtaTile;
};

export function CtaDuo({ primary, secondary }: CtaDuoProps) {
  return (
    <Reveal className="cta-duo">
      <div className="cta-tile cta-day">
        <small>{primary.label}</small>
        <h2>{primary.title}</h2>
        <ButtonLink withArrow to={primary.to} variant="dayDark" label={primary.action} />
      </div>
      <div className="cta-tile cta-night">
        <small>{secondary.label}</small>
        <h2>{secondary.title}</h2>
        <ButtonLink withArrow variant="dawn" to={secondary.to} label={secondary.action} />
      </div>
    </Reveal>
  );
}
